
const NoResult = () => {
    return (
        <div>
            <p>Không có kết quả </p>
        </div>
    )
}
export default NoResult